import { SVGProps } from 'react'

const ArrowForward = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="19"
      height="14"
      viewBox="0 0 19 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m12.826 13.661 5.437-5.016A2.24 2.24 0 0 0 19 7c0-.616-.265-1.208-.737-1.645L12.826.34a1.33 1.33 0 0 0-.894-.34 1.32 1.32 0 0 0-.893.34 1.2 1.2 0 0 0-.278.379 1.1 1.1 0 0 0 0 .897q.1.215.278.38l4.17 3.838H1.267c-.336 0-.658.123-.896.341A1.12 1.12 0 0 0 0 7c0 .31.134.606.371.825.238.219.56.342.896.342H15.21l-4.17 3.838a1.12 1.12 0 0 0-.375.824c0 .31.132.607.369.826.237.22.559.344.895.345s.66-.12.898-.339"
        fill={props.color ? props.color : '#1A1E3D'}
      />
    </svg>
  )
}

export default ArrowForward
